'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CardBoddy;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Spinner = require('../Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function CardBoddy(_ref) {
  var isLoading = _ref.isLoading,
      children = _ref.children;

  if (isLoading) {
    return _react2.default.createElement(_Spinner2.default, {
      isVisible: isLoading,
      size: 'small'
    });
  }

  return children;
}

CardBoddy.propTypes = {
  isLoading: _propTypes2.default.bool,
  children: _propTypes2.default.node
};
CardBoddy.defaultProps = {
  isLoading: null,
  children: null
};